import { AbstractControl, ValidatorFn } from '@angular/forms'


export function equalFieldValidator(oppositeCtrl: AbstractControl): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const val: string = control.value;
        const youFormVal: string = oppositeCtrl.value;

        if (val) {
            if (youFormVal) {
                if (val.toLowerCase() === youFormVal.toLowerCase()) {
                    return {valueEquality: true}
                }
            }
        }

        return null;
    }
}